import apiUtil from "@/services/apiUtil.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
import BaseModelAuditUploadDocument from "@/models/BaseModelAuditUploadDocument.js";

const state = {
    response: ''
}

const mutations = {
    Update_Obj: (state, text) => {
        state.response = text;
    }
}

const actions = {
    async triggerWorkflow({
        dispatch,
        commit
    }, workflow) {
        
        return await apiUtil.methods
                 .triggerWorkflowByItemIds(
                   workflow.itemIds
                 )
                 .catch(error => {
                   console.log(error);
                   throw error;
                 })
                 .finally(() => {});
     },

    // create multiple Items
    async CreateAllItems({
        dispatch,
        commit
       }, createItem) {
        let responseArray = await dispatch("createAllData", createItem);
        await dispatch('getModule/GetUpdatedItems', createItem, {
            root: true
        })
      
        if (responseArray) {
            return responseArray
        } else {  
            throw "Internal Error"   
        }
    },
    // Create Mulitple Items API call
    async createAllData(state, Items) {
        return apiUtil.methods._createAllItems(Items).then((res) => res)
            .catch((error) => {
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    //Create Single Item
    async CreateItems({
        dispatch,
        commit
    }, createItem) {
        let responseArray = await dispatch("createData", createItem);
        await dispatch('getModule/GetItems', createItem.list, {
            root: true
        })
        //return responseArray
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },
    //Create Single Item API call
    async createData(state, createItem) {
        return apiUtil.methods._createItems(createItem.list, createItem.payload).then((res) => res)
            .catch(error => {
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    // Update multiple Items
    async UpdateAllItems({
        dispatch,
        commit
    }, updateItems) {
        let responseArray = await dispatch("updateAllData", updateItems);
        await dispatch('getModule/GetUpdatedItems', updateItems, {
            root: true
        })
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
        
    },
    // Update Mulitple Items API call
    async updateAllData(state, Items) {
        return apiUtil.methods._updateAllItems(Items).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    //Update Single Item
    async UpdateItems({
        dispatch,
        commit
    }, updateItem) {
        console.log(`postModule.UpdateItems... updateItem:`,updateItem)
        let responseArray = await dispatch("UpdateData", updateItem);
        console.log(`postModuleUpdateItems - responseArray:`, responseArray);
        await dispatch('getModule/GetItems', updateItem.list, {
            root: true
        })
        //return responseArray
        if (responseArray) {
            console.log(`postModuleUpdateItems returning responseArray`);
            return responseArray
        } else {
            console.log(`postModuleUpdateItems no responseArray so returning Internal Error`);
            throw "Internal Error"   
        }
    },
    //Update Single Item API call
    async UpdateData(state, updateItem) {
        return apiUtil.methods._updateItems(updateItem.list, updateItem.payload).then((res) => res)
            .catch(error => {

                console.log(`postModule.UpdateData  caught error`,error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    // Delete list
    async DeleteItem({
        dispatch,
        commit
    }, item) {
        let responseArray = await dispatch("deleteItems", item);
        await dispatch('getModule/GetItems', item.list, {
            root: true
        })
        //return responseArray;
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },
    // Delete API
    async deleteItems(state, deleteData) {
        return apiUtil.methods._deleteItems(deleteData.list, deleteData.payload).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },
    async DeleteTempAuditFile(state,fileData){
       //apiUtil.methods._deleteAuditFile(fileData);
    },

    //delete multiple items
    async deleteAllItem({
        dispatch,
        commit
    }, deleteData) {
        let responseArray = await dispatch("deleteAllData", deleteData);
        await dispatch('getModule/GetUpdatedItems', deleteData, {
            root: true
        })
        //return responseArray
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },
    // delete multiple item API call
    async deleteAllData(state, deleteData) {
        return apiUtil.methods._deleteAllItems(deleteData).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    //delete multiple Files
    async DeleteAllFiles({
        dispatch,
        commit
    }, fileData) {
        const documentsObject = {
            Documents: {
                config: BaseModelDocument
            }
        }
        let responseArray = await dispatch("deleteAllFilesData", fileData);
        await dispatch('getModule/GetUpdatedItems', documentsObject, {
            root: true
        })
        //return responseArray
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },
    // delete multiple item API call
    async deleteAllFilesData(state, fileData) {
        return apiUtil.methods._deleteAllFiles(fileData).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    //delete Single Files
    async DeleteFile({
        dispatch,
        commit
    }, fileData) {
        const documentsObject = {
            Documents: {
                config: BaseModelDocument
            }
        }
        let responseArray = await dispatch("deleteFileData", fileData);
        await dispatch('getModule/GetUpdatedItems', documentsObject, {
            root: true
        })
        //return responseArray
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },
    // delete Single item API call
    async deleteFileData(state, fileData) {
        return apiUtil.methods._deleteFile(fileData).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },


    // Post All Files And Update Metadata
    async PostAllFilesAndUpdateMetadata({
        dispatch,
        commit
    }, fileData) {
        const documentsObject = {
            Documents: {
                config: BaseModelDocument
            }
        }
        let responseArray= await dispatch("postAllFilesAndUpdateMetadata", fileData)
        commit('Update_Obj', responseArray);
        await dispatch('getModule/GetUpdatedItems', documentsObject, {
            root: true
        })
        //return responseArray;
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },

      // Post bulk upload audit files
      async PostAllAuditFilesAndUpdateMetadata({
        dispatch,
        commit
    }, fileData) {
        const documentsObject = {
                        BulkUploadAudit: {
                    config: BaseModelAuditUploadDocument
                },
        }
        let responseArray= await dispatch("postAllFilesAndUpdateMetadata", fileData)
        commit('Update_Obj', responseArray);
        await dispatch('getModule/GetUpdatedItems', documentsObject, {
            root: true
        })
        return responseArray;
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    }, 
    // Post All Files And Update Metadata API call
    async postAllFilesAndUpdateMetadata(state, fileData) {
        let tkn = null;
        if (this.getters['authModule/apiTokenIsValid']) {
            tkn = this.getters['authModule/api_idtoken'];
            localStorage.setItem('.eum.file_token',tkn)
        }
        return apiUtil.methods._postAllFilesAndUpdateMetadata(fileData.config, fileData.aryFileMetadata,tkn).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    },

    // Create Joined Items
    async CreateJoinedItems({
        dispatch,
        commit
    }, joinedItems) {
        let Items = joinedItems.joinedObject;
        const getItems = {
            [Items.parentConfig.list]: {
                config: Items.parentConfig
            }
        }
        Items.childConfigs.forEach((element) => {
            let config = {
                "config": element
            }
            getItems[element.list] = config;
        });
        //commit('Update_Obj', await dispatch("createJoinedItems", joinedItems));
        let responseArray = await dispatch("createJoinedItems", joinedItems);
        await dispatch('getModule/GetUpdatedItems', getItems, {
            root: true
        })
        //return responseArray
        if (responseArray) {
            return responseArray
        } else {
            throw "Internal Error"   
        }
    },
    // Create Joined Items API call
    async createJoinedItems(state, joinedItems) {
        return apiUtil.methods._createJoinedItems(joinedItems.joinedObject, joinedItems.createData, joinedItems.ParentKey).then((res) => res)
            .catch(error => {
                console.log(error)
                state.commit("Update_Obj", "error");
            })
            .finally(() => {})
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};